import gql from "graphql-tag";

export const GET_HOME_BUILDING_FACILITIES = gql`
  query GetHomeBuildingFacilities {
    GetHomeBuildingFacilities {
      version
      identifiers {
        key
        value
      }
      facility {
        id
        version
        identifiers {
          key
          value
        }
      }
    }
  }
`;


export const GET_ORDERS = (facilityNumber: string) => gql`
query GetOrders {
    GetOrders(arguments: { facilities: ${JSON.stringify(facilityNumber)}, orderstatuses: "P" }) {
        id
        status
        lines {
            product {
                home {
                    id,
                    identifiers {
                        key,
                        value
                    },
                    sectionCount
                }
            }
        }
    }
}
`;
